/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { metaMcpListMembers } from "../funcs/metaMcpListMembers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMetaMcpMembersResult } from "../models/components/listmetamcpmembersresult.js";
import {
  ListMetaMcpMembersRequest,
  ListMetaMcpMembersSecurity,
} from "../models/operations/listmetamcpmembers.js";
import { unwrapAsync } from "../types/fp.js";
export type MetaMcpMembersQueryData = ListMetaMcpMembersResult;

export function prefetchMetaMcpMembers(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListMetaMcpMembersRequest,
  security?: ListMetaMcpMembersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMetaMcpMembersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMetaMcpMembersQuery(
  client$: GramCore,
  request: ListMetaMcpMembersRequest,
  security?: ListMetaMcpMembersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<MetaMcpMembersQueryData>;
} {
  return {
    queryKey: queryKeyMetaMcpMembers({
      metaMcpServerId: request.metaMcpServerId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function metaMcpMembersQueryFn(
      ctx,
    ): Promise<MetaMcpMembersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(metaMcpListMembers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMetaMcpMembers(
  parameters: {
    metaMcpServerId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "metaMcp", "listMembers", parameters];
}
